import { User } from "./../user";
import { environment } from "./../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-pick",
  templateUrl: "./pick.component.html",
  styleUrls: ["./pick.component.css"],
})
export class PickComponent implements OnInit {
  matId;
  mat;
  currentUserId: User;
  code = null;
  // quizBtn = true;
  // matBtn = true;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService
  ) {}

  async ngOnInit() {
    await this.getCurrentUser();
    this.route.queryParams.subscribe((params) => {
      this.matId = params["mat"];
      this.http
        .get(
          `${environment.apiUrl}/material/${params.mat}/${this.currentUserId}`
        )
        .subscribe((data) => {
          if (data) {
            window.scroll({
              top: 100,
              left: 100,
              behavior: "smooth",
            });
            this.mat = data["data"];
          }
        });
    });
    // if (!this.mat['id']){
    //   this.quizBtn = false;
    // }
    // if(!this.mat["quizz"]["id"]){
    //   this.matBtn = false;
    // }
  }

  getCurrentUser() {
    this.authService.currentUser.subscribe((data) => {
      this.currentUserId = data["data"]["id"];
    });
  }

  goToMat() {
    this.router.navigate(["/mat"], { queryParams: { mat: this.mat["id"] } });
  }

  goToQuizz() {
    this.router.navigate(["/quiz"], {
      queryParams: {
        quiz: this.mat["id"],
        mat_name: this.mat["title"],
        mat_price: this.mat["price"]
      },
    });
  }

  back() {
    this.router.navigate(["/all-mat"]);
  }

  consume_coupon() {
    this.http
      .post(`${environment.apiUrl}/materials/consume-coupon`, {
        code: this.code,
        mat_id: this.matId,
        user_id: this.currentUserId,
      })
      .subscribe(
        (data) => {
          this.toastr.success("Thanks! Now you can view the material");
          this.ngOnInit();
        },
        (error) => {
          this.toastr.error("The code is invalid!");
        }
      );
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    return this.http
      .post(`${environment.apiUrl}/auth/logout`, {})
      .subscribe(
        (data) => (window.location.href = "https://sinnara-app.com/log-in.html")
      );
  }
}
